module.exports = __webpack_public_path__ + "media/images/img_rounge_3-3720d48266207f6cbadf7978f0fd640e.jpg";